define([
    "jquery", "domReady"], function ( $, domReady ){

    domReady( function (){
      setupProductDetailSections();
      setupProductDetailsGrid();
    });


  // Setup product details grid based on content
  function setupProductDetailsGrid() {
    var $productDetailsRatings = $('.product-details-js.pdp-care'),
        $productDetailsContainer = $('.swatches-product-details');

    // If product details ratings is present on page then add proper class
    if ($productDetailsRatings.length) {
      $productDetailsContainer.addClass('product-details--block');
    }
  }

	function setupProductDetailSections () {
		// set up product detail section on swatch layout
		var prodDetailSections = $('.auto-arrange-product-details-js > div').length;
		switch (prodDetailSections) {
			// if case == 1 then width is 100%
			case 1:
				$('.auto-arrange-product-details-js > div').css('width','100%');
				break;
			// if case == 2 then add HR if it doesn't exist
			case 2:
				if (!$('.auto-arrange-product-details-js hr').length){
					$('.auto-arrange-product-details-js > div:nth(1)').after('<hr/>');
				}
				break;
			// if case == 3 then add HR if it doesn't exist and extend 3rd 100% clear left
			case 3:
				$('.auto-arrange-product-details-js > div:nth(2)').css('clear', 'left').css('width', '100%');
				if (!$('.auto-arrange-product-details-js hr').length){
					$('.auto-arrange-product-details-js > div:nth(1)').after('<hr/>');
				}
				break;
			// if case == 4 then add HR if it doesn't exist and 3rd should clear left
			default:
				$('.auto-arrange-product-details-js > div:nth(2)').css('clear', 'left');
				if (!$('.auto-arrange-product-details-js hr').length){
					$('.auto-arrange-product-details-js > div:nth(1)').after('<hr/>');
				}
		} //end switch

	}

// START close Require.JS wrapper
});
// END close Require.JS wrapper
